import { Link } from 'react-router-dom';

const Header = () => {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <header>
      <div className="content">
        <h5 className="main-title" id="long-header-title"><Link to="/" onClick={scrollToTop}>Jonah Lucy Heywood</Link></h5>
        <h5 className="main-title" id="short-header-title"><Link to="/" onClick={scrollToTop}>JLH</Link></h5>
        <ul>
          <li id="header-nav-games"><h6 className="nav"><Link to="/games" onClick={scrollToTop}>Games</Link></h6></li>
          <li id="header-nav-modding"><h6 className="nav"><Link to="/lucymod" onClick={scrollToTop}>Modding</Link></h6></li>
          <li id="header-nav-web-toys"><h6 className="nav"><Link to="/toys" onClick={scrollToTop}>Web Toys</Link></h6></li>
          <li className="icon"><a href="https://bsky.app/profile/minibonzo.bsky.social" target="_blank"><img src="/images/icons/bluesky-icon.svg" alt="Bluesky Logo" /></a></li>
        </ul>
      </div>
    </header>
  );
}

export default Header;